import { FileDownloader } from "../../../../Components/FileDwnLodrLab/FileDownloader";
export default function Hash_Crack() {
  return (
    <FileDownloader
      answerText={"Iamtheflag"}
      fileName={"Hash Crack.rar"}
      hint={
        " The answer is locked inside an MD5 hash , Maybe an MD5 cracker can help you break it? 💻🚀"
      }
      labInfo={
        "A hacker left a cryptic hash behind after breaching the company’s network. Can you crack it and uncover the password to access the CEO’s secure vault?"
      }
      subject={"CryptoGraphy"}
      title={"Hash Crack"}
    />
  );
}
